
export enum ActorType {
  COMPANY = "company",
  REAL_ESTATE = "real_estate",
  KICKBACK = "kickback",
  CAMPAIGN = "campaign",
  COMPENSATION = "compensation",
  REFUND = "refund",
  USER = "user",
  SYSTEM = "system",
  BOOKINGS_EXTERNAL = "bookings_external",
}